import React from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { connect } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { EditCommandCell, MomentCommandCell } from "../../components/Command";
import {
  get,
  insertItem,
  updateItem,
  deleteItem,
} from "../../redux/actions/groupActions";
import { Helmet } from "react-helmet";
import { excelIconUrl } from "../../constants";
import { Button } from "@progress/kendo-react-buttons";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { MyCommandCell } from "./myCommandCell";
import { ChecklistGroupType } from "../../constants/hygeian";
const editField = "inEdit";

const dataState = {
  sort: [{ field: "note.id", dir: "desc" }],
  take: 10,
  skip: 0,
  //group: [{ field: "site.siteName" }],
};

class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canCreate: false,
      canRead: false,
      canUpdate: false,
      canDelete: false,
      dataState: dataState,
      editItem: {},
      group: [],
    };
  }

  // enterEdit = (item) => {
  //   this.setState({
  //     openEditForm: true,
  //     editItem: item,
  //     isEditMode: true,
  //     isDelete: false,
  //     isNew: false,
  //   });
  // };

  enterDelete = (item) => {
    this.setState({
      openEditForm: true,
      isEditMode: false,
      editItem: item,
      isDelete: true,
      isNew: false,
    });
  };

  enterNew = (item) => {
    this.setState({
      openEditForm: true,
      isEditMode: false,
      editItem: null,
      isDelete: false,
      isNew: true,
      //checklistTemplate: this.props.dataItem,
    });
  };

  handleSubmit = (event) => {
    //Do update of edit data
    //console.log(event);
    this.setState({ openEditForm: false });
  };

  handleCancelEdit = () => {
    this.setState({ openEditForm: false });
  };

  MyEditCommandCell = (props) => (
    <EditCommandCell
      {...props}
      disabled={!this.state.canRead}
      enterEdit={this.enterEdit}
      icon={<EditIcon />}
    />
  );
  MyDeleteCommandCell = (props) => (
    <EditCommandCell
      {...props}
      disabled={!this.state.canDelete}
      enterEdit={this.enterDelete}
      icon={<DeleteIcon />}
    />
  );

  MyMomentCommandCell = (props) => (
    <MomentCommandCell
      {...props}
      date={new Date(props.dataItem.note.dateCreated)}
    />
  );

  componentDidMount() {
    this.props.get();
    this.setState({
      canCreate:
        this.props.claims["toolboxtalk_management:canCreate"] === "true",
      canRead: this.props.claims["toolboxtalk_management:canRead"] === "true",
      canUpdate:
        this.props.claims["toolboxtalk_management:canUpdate"] === "true",
      canDelete:
        this.props.claims["toolboxtalk_management:canDelete"] === "true",
    });
  }

  componentWillUnmount() { }

  dataStateChange = (e) => {
    this.setState({
      ...this.state,
      dataState: e.dataState,
    });
  };

  expandChange = (event) => {
    let toolboxTalkData = this.state.toolboxTalk;
    toolboxTalkData.forEach((toolboxTalk) => {
      //console.log(toolboxTalk, event);
      if (toolboxTalk.toolboxTalk.id !== event.dataItem.toolboxTalk.id) {
        toolboxTalk.expanded = false;
      }
    });
    this.setState({ toolboxTalk: toolboxTalkData });
    event.dataItem.expanded = !event.dataItem.expanded;
    this.forceUpdate();
  };

  export = () => {
    if (this._export !== null) {
      let data = this.props.note;
      let dataState = {
        filter: this.state.dataState.filter,
        //group: this.state.dataState.group,
      };
      this._export.save(process(data, dataState), this._grid.columns);
    }
  };

  CommandCell = (props) => (
    <MyCommandCell
      {...props}
      edit={this.enterEdit}
      remove={this.remove}
      add={this.add}
      discard={this.discard}
      update={this.update}
      cancel={this.cancel}
      editField={editField}
    />
  ); // modify the data in the store, db etc

  remove = (dataItem) => {
    //console.log("remove", dataItem);
    this.props.deleteItem(dataItem);
    //this.props.toggleGroupGrid();
    setTimeout(() => {
      let newData = this.state.group.filter((item) => {
        return item !== dataItem;
      });
      //console.log("newData", newData);
      this.setState({
        group: newData,
      });
    }, 1000);
  };
  add = (dataItem) => {
    //console.log("dataItem", dataItem);
    dataItem[editField] = false;
    dataItem["GroupTypeName"] = ChecklistGroupType;
    dataItem["EnterpriseId"] = this.props.entid;
    this.props.insertItem(dataItem);
    let newData = this.state.group.map((item) =>
      item[editField] === true ? dataItem : item
    );
    this.setState({
      group: newData,
    });
  };
  update = (dataItem) => {
    dataItem.inEdit = false;
    this.props.updateItem(dataItem);
    let newData = this.state.group.map((item) =>
      item.id === dataItem.id ? dataItem : item
    );

    this.setState({
      group: newData,
    });
  }; // Local state operations

  discard = (dataItem) => {
    const newData = [...this.state.group];
    newData.splice(0, 1);
    this.setState({
      group: newData,
    });
  };
  cancel = (dataItem) => {
    const originalItem = this.getItems().find((p) => p.id === dataItem.id);
    const newData = this.state.group.map((item) =>
      item.id === originalItem.id ? originalItem : item
    );
    this.setState({
      group: newData,
    });
  };

  getItems = () => {
    return this.props.group;
  };

  enterEdit = (dataItem) => {
    let newData = this.state.group.map((item) =>
      item.id === dataItem.id ? { ...item, inEdit: true } : item
    );
    this.setState({
      group: newData,
    });
  };
  itemChange = (event) => {
    //console.log(event);
    const field = event.field || "";
    const newData = this.state.group.map((item) =>
      item[editField] === true ? { ...item, [field]: event.value } : item
    );
    this.setState({
      group: newData,
    });
  };
  addNew = () => {
    if (this.state.group.filter((e) => e[editField] === true).length === 0) {
      const newDataItem = {
        inEdit: true,
      };
      this.setState({
        group: [newDataItem, ...this.state.group],
      });
    }
  };

  render() {
    let groupStateLength = this.state.group.filter((f) => {
      return f[editField] !== true;
    })?.length;
    let groupPropsLength = this.props?.data?.length;
    //console.log("groupPropsLength", groupPropsLength);
    if (
      groupStateLength !== groupPropsLength &&
      this.props.data?.length > 0 &&
      this.state.group.filter((f) => {
        return f[editField] === true;
      }).length === 0
    ) {
      this.setState({
        group: this.props.data,
      });
      //console.log(this.props.data);
    }

    return (
      <React.Fragment>
        <Helmet title="Groups" />
        {/*<PageNameBarComponent pageName={"Groups"} />*/}
        <ExcelExport ref={(exporter) => (this._export = exporter)} />
        <Grid
          id={this.props.group}
          //detail={ChecklistTaskTemplates}
          onItemChange={this.itemChange}
          pageable
          data={process(this.state.group, this.state.dataState)}
          {...this.state.dataState}
          editField={editField}
          onExpandChange={this.expandChange}
          onDataStateChange={this.dataStateChange}
          dataItemKey={"id"}
          ref={(grid) => {
            this._grid = grid;
          }}
        >
          {this.state.canCreate && (
            <GridToolbar>
              <div
                title="Add new"
                className="k-button k-primary"
                onClick={this.addNew}
              >
                New Group
              </div>
              <Button
                title="Export Excel"
                className="k-button k-primary exportToExcel"
                onClick={this.export}
                imageUrl={excelIconUrl}
              ></Button>
            </GridToolbar>
          )}
          <GridColumn
            field="name"
            title={"Name"}
            editor={"text"}
            editable={true}
          />

          <GridColumn cell={this.CommandCell} width={"200"} />
          {/*<GridColumn*/}
          {/*  title={"Delete"}*/}
          {/*  filterable={false}*/}
          {/*  cell={this.MyDeleteCommandCell}*/}
          {/*  width={"78"}*/}
          {/*/>*/}
          {/*<GridColumn*/}
          {/*  title="Deployment"*/}
          {/*  filterable={false}*/}
          {/*  cell={this.MyEditCommandCell}*/}
          {/*/>*/}
        </Grid>
        {/*{this.state.openEditForm && (*/}
        {/*  <Note*/}
        {/*    canCreate={this.state.canCreate}*/}
        {/*    canRead={this.state.canRead}*/}
        {/*    canUpdate={this.state.canUpdate}*/}
        {/*    canDelete={this.state.canDelete}*/}
        {/*    cancelEdit={this.handleCancelEdit}*/}
        {/*    handleSubmit={this.handleSubmit}*/}
        {/*    item={this.state.editItem}*/}
        {/*    isEditMode={this.state.isEditMode}*/}
        {/*    isDelete={this.state.isDelete}*/}
        {/*    isNew={this.state.isNew}*/}
        {/*  />*/}
        {/*)}*/}

        {this.props.loading && (
          <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
          </div>
        )}
        {/*{this.props.instruments}*/}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    claims: state.authReducer.user.profile.claims,
    group: state.groupReducer.group,
    entid: state.authReducer.user.profile.entid,
  };
};

const mapDispatchToProps = { get, insertItem, updateItem, deleteItem };
//export default Instruments;
export default connect(mapStateToProps, mapDispatchToProps)(Groups);
